<template>
  <v-card>
    <v-card-title>メニューの指定</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <!-- <div v-for="(head, i) in headers" :key="i" class="mb-4"></div> -->
          <v-col>
            <v-text-field
              label="アイコン"
              v-model="returnData.icon"
              required
            ></v-text-field>
            <v-text-field
              label="タイトル"
              v-model="returnData.title"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <div v-for="(item, i) in returnData.items" :key="i" class="mb-4">
          <v-row>
            <v-col cols="1"> </v-col>
            <v-col cols="6">
              <v-text-field
                label="To"
                v-model="item.to"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field
                label="text"
                v-model="item.text"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="success" @click="del">削除</v-btn>
      <v-btn color="success" @click="add">追加</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success" @click.once="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    items: Array,
    position: Number,
  },
  data() {
    return {
      returnData: {
        icon: this.icon,
        title: this.title,
        items: this.items,
        position: this.position,
      },
    };
  },
  methods: {
    submit() {
      this.$emit("clickSubmit", this.returnData);
    },
    add() {
      this.returnData.items.push({
        To: "/URL",
        text: "text",
      });
    },
    del() {
      if (this.returnData.items.length > 1) {
        this.returnData.items.splice(-1, 1);
      }
    },
  },
};
</script>
